import type { IconData } from '@stacksjs/iconify-core'

export const speaker2Flat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" fill-rule=\"evenodd\" d=\"M24 46.5c-5.926 0-10.206-.242-13.041-.491c-3.3-.29-5.765-2.887-5.993-6.152C4.74 36.592 4.5 31.403 4.5 24s.239-12.592.466-15.857S7.66 2.281 10.96 1.991C13.794 1.742 18.074 1.5 24 1.5s10.206.242 13.041.491c3.3.29 5.765 2.887 5.993 6.152c.227 3.265.466 8.454.466 15.857s-.239 12.592-.466 15.857s-2.693 5.862-5.993 6.152c-2.835.249-7.115.491-13.041.491\" clip-rule=\"evenodd\"/><path fill=\"#2859c5\" d=\"M24 7.5a3.5 3.5 0 1 0 0 7a3.5 3.5 0 0 0 0-7\"/><path fill=\"#2859c5\" fill-rule=\"evenodd\" d=\"M13.5 30c0-5.799 4.701-10.5 10.5-10.5S34.5 24.201 34.5 30S29.799 40.5 24 40.5S13.5 35.799 13.5 30M27 30a3 3 0 1 1-6 0a3 3 0 0 1 6 0\" clip-rule=\"evenodd\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default speaker2Flat
